import formDataReducer from './formReducer';

export * from './formActionTypes';
export default formDataReducer;
